import React, {Component} from 'react';
import './App.css';
import Knowledge from './Components/Knowledge';

import {
    BrowserRouter as Router,
    Route,
    Link
} from 'react-router-dom';

let BASENAME = '/support';
if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
    BASENAME = '/';
}

class App extends Component {
    render() {
        return (
            <Router basename={BASENAME}>
                <Route path={"/"} render={(props) => <Knowledge {...props} />} />
            </Router>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js